import axios from "axios";
import { BASE_URL } from "../config/config";
import { getToken, getCSRFToken, getUserRole, getUserLevel, getUserId } from "../helpers/index";

const instance = axios.create({
  baseURL: BASE_URL,
});

instance.interceptors.request.use(
  (config) => {
    const token = getToken();
    const CSRF_TOKEN = getCSRFToken();
    
    if (token) config.headers["Authorization"] = "Bearer " + token;
    
    if (CSRF_TOKEN) config.headers["X-XSRF-TOKEN"] = CSRF_TOKEN;
    
    const role = getUserRole();
    const userLevel = getUserLevel();
    const userId = getUserId();
    
    if (role) config.headers["X-User-Role"] = role;
    if (userLevel !== null && userLevel !== undefined) config.headers["X-User-Level"] = userLevel.toString();
    if (userId) config.headers["X-User-Id"] = userId.toString();
    
    config.withCredentials = true;
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const errorMessage = error.response?.data?.message || '';
      const errorStatus = error.response?.data?.status || '';
      const requestUrl = error.config?.url || '';
      
      if (requestUrl && requestUrl.includes('csrf')) {
        console.log('CSRF endpoint error (ignored):', requestUrl);
        return Promise.reject(error);
      }
      
      const isAuthError = 
        errorMessage.toLowerCase().includes('token') ||
        errorMessage.toLowerCase().includes('unauthorized') ||
        errorMessage.toLowerCase().includes('authentication') ||
        errorMessage.toLowerCase().includes('invalid') ||
        errorMessage.toLowerCase().includes('expired') ||
        errorStatus === 'expired';
      
      if (isAuthError) {
        console.log('Authentication error detected, logging out...', {
          message: errorMessage,
          url: requestUrl
        });
        localStorage.removeItem("authToken");
        window.location.href = "/";
      } else {
        console.warn('401 error but not authentication-related:', {
          message: errorMessage,
          url: requestUrl,
          status: errorStatus
        });
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
